<template>
  <section class="n-view-register h-screen p-10 flex justify-center items-center">
    <NCard class="w-full max-w-[450px] shadow-md">
      <div class="text-center">
        <img class="mx-auto p-8" src="/images/logo-dark.png" alt="" />
        <template v-if="hasError">
          <div class="m-4 text-lg text-red-500">
            <span>{{ t(errorCode, PREFIX.ERROR_CODE) }} </span>
          </div>
          <div class="my-4">
            <NButton size="middle" type="primary" @click="routerTo('/login')">
              <span>{{ $tl('backToLogin') }}</span>
            </NButton>
          </div>
        </template>
      </div>
      <div class="mt-10 mb-3 text-center text-base text-gray-600 grid items-center gap-3 grid-flow-col place-content-center">
        {{ COPYRIGHT }}
        <NChannelSwitch />
        <NLanguageSwitcher />
        <NHelper />
      </div>
    </NCard>
  </section>
</template>

<script setup>
import {domainEvent, useLanguage, useRouter} from '@front/hooks';
import {computed, onBeforeMount} from 'vue';
import {COPYRIGHT} from '@front/constant';
import {DEFAULT_PORTAL} from '@/glue';
import {isEmpty} from 'lodash-es';

const { tl, t, PREFIX } = useLanguage();
const { router, routerTo } = useRouter();

const query = router.currentRoute.value.query;

const token = query?.token;
const agent = query?.agent;
const chn = query?.authType;
// const action = query?.action;
const message = query?.message;
const errorCode = query?.errorCode;
const quickLoginAction = query?.quickLoginAction;
const hasError = computed(() => !isEmpty(errorCode));

onBeforeMount(() => {

  if (!hasError.value) {
    if(quickLoginAction === 'REGISTER'){
      window.fbq?.('track', 'CompleteRegistration', { content_name: 'registration', contents: { channel: chn, agent: agent }, status: true });
    }
    domainEvent.dispatch('LOGIN');
    routerTo(DEFAULT_PORTAL);
  }
});
</script>

<style lang="less">
.n-view-register {
  background-image: url('/images/shape01.png');
  background-position: center;

  .n-language-switcher {
    gap: 6px;
  }
}
</style>
